import { api } from "src/services/api";

// Assets
import { ReturnData } from "src/types/return-data";
import { catchError } from "src/helpers";

// Http Requests
export const doGetUserRequest = async (
  term: string,
  query: string
): Promise<ReturnData> => {
  const defaultErrorMessage =
    "Não foi possível buscar pelo usuário. Tente novamente.";
  try {
    const { data, status } = await api.get(
      `/api/softphone/ame/uda/?ordering=usuario__nome&${term}=${query}`
    );

    if (status == 200) {
      return {
        success: true,
        data: data,
      };
    }

    return {
      success: false,
      message: defaultErrorMessage,
    };
  } catch (error) {
    return catchError(error, defaultErrorMessage);
  }
};

export const doPausePaRequest = async (
  pauseType: string
): Promise<ReturnData> => {
  const defaultErrorMessage = "Falha ao pausar PA.";

  try {
    const { status } = await api.post(
      "/api/softphone/ame/atendimento/atendente/pausa/",
      {
        tipo: pauseType,
      }
    );

    if (status === 201) {
      return {
        success: true,
      };
    }

    return {
      success: false,
      message: defaultErrorMessage,
    };
  } catch (error) {
    return catchError(error, defaultErrorMessage);
  }
};

export const doGetCallHistoryRequest = async (): Promise<ReturnData> => {
  const defaultErrorMessage =
    "Não foi possível buscar pelo histórico. Tente novamente.";
  try {
    const { data, status } = await api.get(
      `/api/softphone/ame/atendimento/historico/`
    );

    if (status == 200) {
      return {
        success: true,
        data: data,
      };
    }

    return {
      success: false,
      message: defaultErrorMessage,
    };
  } catch (error) {
    return catchError(error, defaultErrorMessage);
  }
};

export const doUnpausePaRequest = async (): Promise<ReturnData> => {
  const defaultErrorMessage = "Falha ao despausar PA.";

  try {
    const { status } = await api.delete(
      "/api/softphone/ame/atendimento/atendente/pausa/"
    );

    if (status === 204) {
      return {
        success: true,
      };
    }

    return {
      success: false,
      message: defaultErrorMessage,
    };
  } catch (error) {
    return catchError(error, defaultErrorMessage);
  }
};

export const doGetPauseTypesRequest = async (): Promise<ReturnData> => {
  const defaultErrorMessage = "Falha ao buscar pausas na API.";

  try {
    const { status, data } = await api.get("/api/softphone/pausas/");

    if (status === 200) {
      return { success: true, data: data.data };
    }

    return {
      success: false,
      message: `${defaultErrorMessage}. Erro: ${status}`,
    };
  } catch (error) {
    return catchError(error, defaultErrorMessage);
  }
};
